import { fetchIPERC } from "../http-common";

const postListarProcesosLineaBaseLaPoderosa = (filter: any) => {
  return fetchIPERC.post(`ProcesoLineaBase/LitarProcesosLaPoderosa`, filter);
};

const ProcesoLineaBaseService = {
  postListarProcesosLineaBaseLaPoderosa,
};

export default ProcesoLineaBaseService;
